import {
    CustomVue,
} from 'vuex';

/**
 * Custom go back which handles undefined routes in case of refreshes or direct URL hits
 *
 * @param {CustomVue} vm - Vue Instance
 * @param {string} fromPath - Path we are coming from, if not specified default to router.back()
 * @param {string} fallback - fallback route in case previous route is not valid (Defaults to home)
 * @returns {void} - void
 */
export const goBack = (vm: CustomVue, fromPath = '', fallback = '/home'): void => {
    if (fromPath || !document.referrer.includes(window.location.host)) {
        const toPath = ['/', ''].includes(fromPath) ? fallback : fromPath;

        vm.$router.push(toPath);
    } else {
        vm.$router.back();
    }
};